import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import FieldError from '@/app/pages/notifications/announcements/components/FieldError';
import { useAnnouncementValidityForm } from '@/app/pages/notifications/announcements/core/_hooks';

type AnnouncementValidityModalProps = {
  announcementId: string;
  startDate: string;
  endDate?: string;
  onClose: () => void;
};

function AnnouncementValidityModal({ announcementId, startDate, endDate, onClose }: AnnouncementValidityModalProps) {
  // O backend só move o início enquanto ele está no futuro.
  const hasStarted = new Date(startDate) <= new Date();

  const { formik, isSaving } = useAnnouncementValidityForm(announcementId, startDate, endDate, onClose);

  return (
    <Modal centered show onHide={onClose}>
      <form onSubmit={formik.handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Alterar vigência</Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex flex-column gap-4">
          <div>
            <label className="form-label fs-6 fw-bold text-gray-700 required" htmlFor="validity_start">
              Início
            </label>
            <input
              className="form-control"
              disabled={hasStarted}
              id="validity_start"
              name="startDate"
              type="datetime-local"
              value={formik.values.startDate}
              onChange={formik.handleChange}
            />
            <FieldError message={formik.errors.startDate} />
          </div>
          <div>
            <label className="form-label fs-6 fw-bold text-gray-700" htmlFor="validity_end">
              Fim (opcional)
            </label>
            <input
              className="form-control"
              id="validity_end"
              name="endDate"
              type="datetime-local"
              value={formik.values.endDate}
              onChange={formik.handleChange}
            />
            <FieldError message={formik.errors.endDate} />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="text-gray-600" variant="secondary" onClick={onClose}>
            Cancelar
          </Button>
          <Button disabled={isSaving} type="submit" variant="primary">
            Salvar
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}

export default AnnouncementValidityModal;
